module.exports = __webpack_public_path__ + "static/contact-image-964916039dd5849b16937d0bb0f633ea.svg";